import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
    {
        title: 'طراحی وب سایت فروشگاهی',
        text: 'ساخت و توسعه وب سایت فروشگاهی با بهترین طراحی بصری درآمیخته با کسب و کار شما و بهره مندی از امنیت بالا در کنار بسیاری از موارد کاربردی دیگر نظیر پنل پیامکی و محاسبات اطلاعات وب سایت با استفاده از هوش مصنوعی و دیگر متود های روز دنیا.',
    },
    {
        title: 'طراحی وب سایت هویتی',
        text: 'طراحی و ساخت وب سایت هویتی کمک شایانی به شناختن کسب و کار شما می کند و به نحوی هویت الکترونیکی شمارا تامین می کند. شرکت توسعه فناوران رایا با استفاده از تخصص خود این امر را برای شما به نحو شایسته انجام می دهد تا سایتی زیبا در کنار طراحی یکتا داشته باشد.',
    },
    {
        title: 'طراحی اپلیکیشن تحت وب',
        text: 'شرکت توسعه فناوران رایا با استفاده از به روز ترین دانش برنامه نویسی از جمله هوش مصنوعی اپلیکیشن متناسب با کسب کار شمارا به صورت تحت وب طراحی می کند تا مناسب برای تمامی سیستم عامل ها باشد.',
    },
    {
        title: 'رشد کسب و کار',
        text: 'یکی از مهم ترین و اساسی ترین توانایی شرکت توسعه فناوران رایا فراهم کردن زیر ساخت رشد برای کسب و کار شما می باشد، ما مفتخریم که با دانش خود در زمینه مدیریت، مدیریت فرایند، مهندسی داده ها و... کمک قابل توجهی به مدیران کسب و کار ها کنیم.',
    },
];

const Features = () => (
    <div className="sam__features section__padding" id="features" dir='rtl'>
        <div className="sam__features-heading">
            <h1 className="gradient__text">برخی از خدمات شرکت توسعه فناوران رایا:</h1>
            <p><a href='#footer'>برای مشاوره و اطلاع از دیگر خدمات رایا اینجا کلیک کنید.</a></p>
        </div>
        <div className="sam__features-container">
            {featuresData.map((item, index) => (
                <Feature title={item.title} text={item.text} key={item.title + index} />
            ))}
        </div>
    </div>
);

export default Features;
